<template>
  <div id="wrapper">
    <nav class="navbar navbar-custom navbar-fixed-top" role="navigation">
      <div class="top-area">
        <div class="container">
          <div class="row">
            <div class="col-sm-5 col-md-5">
              <p class="bold text-left">{{sourceHome.workdays + ': 8:00 - 20:00 '}}</p>
              <p class="bold text-left">{{sourceHome.workdays1 + ': 8:00 - 16:00 '}}</p>
            </div>
            <!-- desktop  place for language-->
            <div class="col-sm-2 col-md-2">
                <div class="btn-group div-lang-container">
                  <button type="button" class="btn btn-link lang-button-desktop" @click="changeLanguage(selectedLanguage === 'русский' ? 'he_IL': 'ru_RU', true)">
                     <i class="fa fa-globe"></i>
                     <span>{{selectedLanguage === 'русский' ? 'עברית': 'русский'}}</span>
                  </button>                 
                </div>
            </div>
            <div class="col-sm-5 col-md-5">
              <div class="top-right-header-container">
                <p class="bold text-right">{{sourceHome.telephone + ': 03-6138935, 050-8691442'}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container navigation">

        <div class="navbar-header page-scroll">
          <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-main-collapse">
                    <i class="fa fa-bars"></i>
                </button>

          <!-- here insert languahe -->
           <div :class="direction === 'ltr' ? 'div-lang-container-mobile': 'div-lang-container-mobile-heb'  " v-bind:style="'direction:' + direction">
            <button type="button" class="btn btn-link lang-button" 
              @click="changeLanguage(selectedLanguage === 'русский' ? 'he_IL': 'ru_RU', true)">
              {{selectedLanguage === 'русский' ? 'עברית': 'русский'}}
            </button>
          </div>    
          <!-- end language -->
          <a class="navbar-brand" href="index.html">
            <div class="d-flex">
              <img src="image/logo.jpg" alt="" class="logo-img" />
              <div class="logo-div-name">
                <span class="logo-name">keren center</span>
                <span class="logo-subname">alternative medicine</span>
              </div>       
            </div>
          </a>
        </div>

        <!-- Collect the nav links, forms, and other content for toggling -->
        <div class="collapse navbar-collapse navbar-right navbar-main-collapse">
          <ul class="nav navbar-nav" v-bind:style="'direction:' + direction">
            <li v-for="mItem in mainMenu" v-bind:key="mItem._id">              
              <router-link class="nav-link" :to="mItem.item_link" data-toggle="collapse" data-target=".navbar-collapse">
                {{mItem.title}}
              </router-link>
            </li>         
          </ul>
          <div v-bind:style="'direction:' + direction" :class="direction === 'rtl'? 'mobile-li-info mobile-li-info-heb': 'mobile-li-info'">
              <p>{{sourceHome.workdays + ': 9:00 - 20:00 '}}</p>
              <p>{{sourceHome.telephone + ': 03-6138935, 050-8691442'}}</p>
          </div>
         <!-- old  place mobile -->

        </div>
        <!-- /.navbar-collapse -->
      </div>
      <!-- /.container -->
    </nav>
</div>
</template>

<script>
import { getDataFromServer } from '../utils/DataProvider'
import { InitSource } from '../sources/language_provider'
  export default {
    data: () => {
      return{        
         sourceHome: {workdays:'', telephone: '', workdays1: ''},
         mainMenu: [],
         selectedLanguage: '', 
         direction: '',
         title: '',
         description: '',
         keywords: '',
      }     
    },  
   
    methods:{
      changeLanguage(lang, redirect){
        switch(lang){
          case"he_IL":
            this.selectedLanguage= 'עברית'
          break;
          case"ru_RU":
            this.selectedLanguage= 'русский'
          break;
        }
        InitSource(lang, this.$store, () => {
          console.log("changeLanguage set headers: ", this.$store.getters.SOURCE_JSON.general)
          this.sourceHome.workdays = this.$store.getters.SOURCE_JSON.general.workdays
          this.sourceHome.workdays1 = this.$store.getters.SOURCE_JSON.general.workdays1
          this.sourceHome.telephone = this.$store.getters.SOURCE_JSON.header.telephone          
          this.description = this.$store.getters.SOURCE_JSON.home.description
          this.keywords = this.$store.getters.SOURCE_JSON.home.keywords
          document.title = this.$store.getters.SOURCE_JSON.home.title 
        });

        if(lang !== this.$store.getters.CURRENT_LANGUAGE){
          this.$store.dispatch('SET_CURRENT_LANGUAGE', lang)
        }

        console.log("changeLanguage set headers: ", '1',  this.sourceHome)
        let desc = document.querySelector("meta[name='description']")
        desc.setAttribute("content", this.description)
        let keywords = document.querySelector("meta[name='keywords']")
        keywords.setAttribute("content", this.keywords)
        
        this.getMenuByLanguage(lang)
        this.direction = lang === 'he_IL' ? 'rtl':'ltr'
        if(redirect){
          this.$router.push('/')
        }        
      },

      getMenuByLanguage(lang){
        console.log("get menu by lang: ", lang)
        getDataFromServer('get_menu_by_lang_id', {id: 'main_menu', language: lang})
        .then(obj => { 
          if(obj.data.success === true){ 
            console.log("menu by lang: ", obj.data.data);           
            this.mainMenu = obj.data.data.menu_items                           
          }
          else{
            this.flash('get menu error: ' + obj.data.text , 'error', {timeout: 5000})
          }          
        })
        .catch(err => { 
          this.flash('get menu error: ' + obj.data.text , 'error', {timeout: 5000})
        })
      }       
    },
    created(){
      console.log("created HEADER **************** ")         
      //get site data
      getDataFromServer('get_homepage_data', null)
      .then(obj => {
        
        if(this.$store.getters.CURRENT_LANGUAGE === ''){
            this.$store.dispatch('SET_CURRENT_LANGUAGE', obj.data.config.data.language)
        }        
        this.currentLanguage = this.$store.getters.CURRENT_LANGUAGE          
        this.$store.dispatch('INIT_SITE_DATA', obj.data)
        
        let arrMenus = obj.data.menus.data;
        for(let i = 0; i < arrMenus.length; i++){
            if(arrMenus[i].menu_id === 'main_menu'){
              this.mainMenu = arrMenus[i].menu_items
            }
        }
        console.log("main menu: ", this.mainMenu)
        console.log("init header language ***************** ")
        InitSource(this.$store.getters.CURRENT_LANGUAGE, this.$store, () => {
          this.sourceHome.workdays = this.$store.getters.SOURCE_JSON.general.workdays
          this.sourceHome.workdays1 = this.$store.getters.SOURCE_JSON.general.workdays1
          this.sourceHome.telephone = this.$store.getters.SOURCE_JSON.header.telephone          
          document.title = this.$store.getters.SOURCE_JSON.home.title
          this.description = this.$store.getters.SOURCE_JSON.home.description
          this.keywords = this.$store.getters.SOURCE_JSON.home.keywords
        });
        this.selectedLanguage = this.$store.getters.CURRENT_LANGUAGE === "ru_RU" ? "русский" : "עברית"        
        
        let desc = document.querySelector("meta[name='description']")
        desc.setAttribute("content", this.description)
        let keywords = document.querySelector("meta[name='keywords']")
        keywords.setAttribute("content", this.keywords)
        
      })
      .catch(err => { }) 
      
      this.$store.subscribe((mutation, state) => {
          if(mutation.type === 'SET_CURRENT_LANGUAGE'){
             console.log("created header subscribe state: ", state) 
             console.log("created header subscribe SET_CURRENT_LANGUAGE: ", this.$store.getters.CURRENT_LANGUAGE) 
             console.log("created header subscribe selecter language: ", this.selectedLanguage) 
             const lang = this.$store.getters.CURRENT_LANGUAGE          
             this.changeLanguage(lang, false)
          }
      })    
    }
  }
</script>

<style scoped>
  .top-right-header-container{
    display: flex;
    text-transform: unset;
    justify-content: flex-end;
  }

  .link-btn{
    margin: 10px;
  }

  .logo-img{
    width: 60px;
    margin-top: -15px;
  }

  .logo-div-name{
    text-transform: uppercase;
    font-weight: 400;
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    color: #957f70;
  }
  
  .logo-name{
    font-size: 12px;
  }

  .logo-subname{
    font-size: 12px;
  }  

  .div-lang-container{
    margin-top: -5px;
    text-transform: unset;
    margin-right: 30px;
  }

  .div-lang-container i{
    font-size: 20px;
    margin-right: 5px;
  }

  .div-lang-container button,
  .div-lang-container button:focus,
  .div-lang-container button:active{
    font-size: 16px;
    color:#fff;
    text-decoration: unset;
  }

  .div-lang-container button:hover
  {
    text-decoration: unset;
    opacity: 0.7;
  }

  .btn.btn-link{
    text-transform: unset;
  }

  .lang-button, 
  .lang-button:focus, 
  .lang-button:active{
    color: #000;
    font-size: 14px !important;
    outline: none;
  } 

  .mobile-li-info,
  .div-lang-container-mobile{
      display: none;
    }

  .mobile-li-info-heb{
    margin-right: 40px;
  }

  .div-lang-container-mobile-heb{
    display: none;    
  }

  .btn-language{
    color: #fff;
  }

  .top-area p{
    margin-bottom: 0px;
  }

  @media(max-width:1200px){
    .logo-img{
      width: 50px;
      margin-top: -10px;
    }    
  }

  @media(max-width:767px){
    .mobile-li-info{      
      display: block;
      /* color: #4ACCD1; */
      margin-left: -2px;
    }

    .mobile-li-info p{
      margin-bottom: 0px;
      margin-top: 0px;
    } 
    
    .div-lang-container-mobile{
      display: block;
      position: absolute;
    right: 55px;
    top: 10px;
    }

    .div-lang-container-mobile-heb{
      
      display: block;   
      position: absolute;
    right: 55px;
    top: 10px;
    }

    .div-lang-container-mobile-heb button, .div-lang-container-mobile button{
      color: #444;      
      margin-left: -15px !important;
      font-size: 12px;
      letter-spacing: 1px;    
      text-transform: uppercase;
      font-weight: 700;
      background: transparent;
      border:0;
    }

    .div-lang-container-mobile button:hover{
      text-decoration: none;
      /* color: #3fbbc0; */
    }

    .lang-button:hover{
      text-decoration: none;
      /* color: #3fbbc0 !important; */
    }
  }
</style>
